import { render, staticRenderFns } from "./CreateStore.vue?vue&type=template&id=0f506baa&scoped=true&"
import script from "./CreateStore.vue?vue&type=script&lang=js&"
export * from "./CreateStore.vue?vue&type=script&lang=js&"
import style0 from "./CreateStore.vue?vue&type=style&index=0&id=0f506baa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f506baa",
  null
  
)

export default component.exports